/* eslint-disable */

import type { MulticallContractConfig } from "../types"
import type { Config } from "@wagmi/core"
import type { Address } from "viem"
import { useEffect, useState } from "react"
import { multicall } from "@wagmi/core"

import type { Token } from "@/domains/core"

import { minimalTokenAbi } from "@/domains/abis"
import { BIGINT_ZERO } from "../constants"
import { makeWeiReturnObject } from "../make-wei-return-object"

type UseCreateBribeProps = {
  account: Address
  token: Token
  chainId: number
  config: Config
  refetchInterval?: number
  bribeAddress: Address
  bribeType: "vote" | "gauge"
  selectedGauge?: Address
}

export type CreateBribeResult = {
  accountBalanceToken: { wei: bigint; value: string }
  gaugeSpendTokenAllowance: { wei: bigint; value: string }
}

export const useCreateBribeLens = ({
  account,
  chainId,
  config,
  token,
  refetchInterval = 5 * 1000,
  bribeAddress,
  bribeType,
  selectedGauge,
}: UseCreateBribeProps): CreateBribeResult => {
  const [result, setResult] = useState<CreateBribeResult>({
    accountBalanceToken: { wei: BIGINT_ZERO, value: "0" },
    gaugeSpendTokenAllowance: { wei: BIGINT_ZERO, value: "0" },
  })

  useEffect(() => {
    let isSubscribed = true

    const fetchData = async () => {
      if (!account || !token.address) return // Add early return if no account
      try {
        const contracts: MulticallContractConfig[] = [
          {
            address: token.address,
            abi: minimalTokenAbi,
            functionName: "balanceOf",
            args: [account],
            chainId: chainId,
          },
          {
            address: token.address,
            abi: minimalTokenAbi,
            functionName: "allowance",
            args: [account, (bribeType === "vote" ? bribeAddress : selectedGauge) as Address],
            chainId: chainId,
          },
        ]
        // @ts-ignore
        const lens = await multicall(config, { contracts })
        // console.log("lensMulticallResult", lens)

        if (isSubscribed) {
          setResult({
            accountBalanceToken: makeWeiReturnObject(lens[0]?.result as bigint, token.decimals),
            gaugeSpendTokenAllowance: makeWeiReturnObject(lens[1]?.result as bigint, token.decimals),
          })
        }
      } catch (error: any) {
        console.error("useCreateBribeLens", error)
      }
    }

    fetchData()

    const intervalId = setInterval(fetchData, refetchInterval)

    return () => {
      isSubscribed = false
      clearInterval(intervalId)
    }
  }, [account, chainId, config, token.address, bribeAddress, bribeType, selectedGauge, refetchInterval])

  return result
}
